import {
  UsersState,
  LOAD_USERS_SUCCESS,
  UserActionTypes,
  UPDATE_USER_FIELD,
  LOAD_USER_BY_ID_SUCCESS,
  LOAD_USERS,
  LOAD_USER_BY_ID,
  UPDATE_USER_SUCCESS,
  EMPTY_USER,
  UPDATE_ROLE,
  ERROR_UPDATING_ROLE,
  User,
  SELECT_ALL_ROLES,
  SELECT_NO_ROLES,
  SELECT_ALL_ROLES_IN_GROUP,
  SELECT_NO_ROLES_IN_GROUP,
  LOAD_EXTERNAL_SUCCESS,
  LOAD_EXTERNAL_USER_BY_ID_SUCCESS,
  UPDATE_EXTERNAL_USER_SUCCESS,
  OPTIONS_LOADED,
  LOADING_OPTIONS, OFFERS_LOADED
} from "./types";
const generator = require('generate-password');

const initialState: UsersState = {
  loading: false,
  loadingUser: false,
  users: [],
  usersFiltered: [],
  editedUser: null,
  externalUsers: [],
  accountTypeOptions: {},
  loadingOptions: false,
  error: ''
};

const EMPTY_USER_TEMPLATE = {
  email: '',
  url: '',
  phone_number: '',
  phone_number_verified: true,
  email_verified: false,
  'cognito:groups': [],
  Enabled: true
}

export function usersReducer(
  state = initialState,
  action: UserActionTypes
): UsersState {
  let user: User = Object.assign({}, EMPTY_USER_TEMPLATE);
  switch (action.type) {
    case LOAD_USERS:
      return {
        ...state,
        loading: true
      }
    case LOAD_USERS_SUCCESS:
      //taking first row for now
      return {
        ...state,
        loading: false,
        users: action.payload
      };

    case LOAD_EXTERNAL_SUCCESS:
      return {
        ...state,
        loading: false,
        externalUsers: action.payload
      };


    case LOAD_USER_BY_ID:
      return {
        ...state,
        loadingUser: true
      };

    case LOAD_USER_BY_ID_SUCCESS:

      return {
        ...state,
        editedUser: action.payload,
        loadingUser: false
      };

    case LOAD_EXTERNAL_USER_BY_ID_SUCCESS:
      let usr = action.payload;
      if (action.payload['custom:account_type']) {
        let acc_type = action.payload['custom:account_type'];
        if (acc_type) {
          usr.account_type = acc_type.type;
        }
      }

      return {
        ...state,
        editedUser: usr,
        loadingUser: false
      };

    case UPDATE_USER_SUCCESS:
    case UPDATE_EXTERNAL_USER_SUCCESS:
      return {
        ...state
      };

    case UPDATE_USER_FIELD:
      let editedUser = Object.assign({}, state.editedUser);
      editedUser[action.payload.field] = action.payload.value;
      return {
        ...state,
        editedUser
      }

    case EMPTY_USER:
      return {
        ...state,
        editedUser: Object.assign({
          temporary_password: generator.generate({
            length: 10,
            numbers: true
          })
        }, EMPTY_USER_TEMPLATE)
      }
    case ERROR_UPDATING_ROLE:
        if(state.editedUser){
          return {
            ...state,
            error: action.payload
          }
        }
    case UPDATE_ROLE:
      if (state.editedUser) {
        let user: User = { ...state.editedUser }
        let userGroups = [...user['cognito:groups']];
        const found = userGroups.findIndex(role => role.GroupName === action.payload);
        if (found === -1) {
          userGroups.push(action.payload)
        } else {
          userGroups.splice(found, 1);
        }
        user['cognito:groups'] = userGroups;
        return {
          ...state,
          editedUser: user,
          error:''
        }
      }
      return state;
    case SELECT_ALL_ROLES:
      user = { ...state.editedUser } as User;
      user['cognito:groups'] = [...action.payload];
      return {
        ...state,
        editedUser: user
      }

    case SELECT_NO_ROLES:
      user = { ...state.editedUser } as User;
      user['cognito:groups'] = [];

      return {
        ...state,
        editedUser: user,
        error:''
      }
    case SELECT_ALL_ROLES_IN_GROUP:
      user = { ...state.editedUser } as User
      user['cognito:groups'] = user['cognito:groups'].concat([...action.payload]);

      return {
        ...state,
        editedUser: user
      }

    case SELECT_NO_ROLES_IN_GROUP:
      user = { ...state.editedUser } as User;
      user['cognito:groups'] = user['cognito:groups'].filter(itm => {
        if (action.payload.find(element => element.GroupName === itm.GroupName)) {
          return false
        }
        return true
      });

      return {
        ...state,
        editedUser: user
      }

    case LOADING_OPTIONS:
      return {
        ...state,
        loadingOptions: true
      }

    case OPTIONS_LOADED:
      return {
        ...state,
        accountTypeOptions: action.payload,
        loadingOptions: false
      }
    case OFFERS_LOADED:
      return {
        ...state,
        offersOptions: action.payload,
        loadingOptions: false
      }
    default:
      return state;
  }
}

